import { getSessionData } from "@repo/shared-utils/common-utils";

/**
 * Gets customer ID from session data for CleverTap analytics
 * Returns undefined if session data is unavailable or customer ID is not present
 * 
 * @returns Promise<string | undefined> - Customer ID or undefined
 * 
 * @example
 * ```ts
 * const customerId = await getCustomerIdForAnalytics();
 * if (customerId) {
 *   cleverTapOverrides.EP_CUSTOMER_ID = customerId;
 * }
 * ```
 */
export const getCustomerIdForAnalytics = async (): Promise<string | undefined> => {
    try {
        const session = await getSessionData();
        return session?.custId;
    } catch {
        // ignore session failures - analytics should not break if session is unavailable
        return undefined;
    }
};

